<template>
  <v-dialog :persistent="loading" v-model="show" width="500">
    <v-card>
      <v-card-title>Criar link de criação de conta</v-card-title>
      <v-card-text>
        <v-alert v-if="!data.user?.id" type="warning" class="mb-0">
          Esse usuário nunca tentou criar uma conta, por isso não é possível
          criar um link. O cliente deve primeiro tentar criar uma conta pela
          plataforma.
        </v-alert>
        <template v-else>
          <platform-selector
            label="Para qual plataforma?"
            v-model="platform"
            class="mb-4"
          />

          <v-select
            v-model="reason"
            :items="types"
            item-text="text"
            item-value="value"
            label="Tipo"
            outlined
            dense
            class="mb-4"
            hide-details
          />

          <v-alert v-if="platform" type="warning">
            <h6>Atenção!</h6>
            Esse link pertence ao cliente <b>{{ data.user.phone }}</b>
            <br />
            Só envie o link se o número for o mesmo do cliente.
          </v-alert>
          <v-checkbox
            v-model="confirm"
            label="Confirmo que o número do cliente é o mesmo informado acima."
          />
          <v-alert v-if="error" type="error">
            {{ error }}
          </v-alert>

          <v-textarea
            v-if="link"
            v-model="link"
            label="Link"
            outlined
            dense
            hide-details
            disabled
            readonly
          />
          <v-btn
            color="primary"
            @click="create"
            :loading="loading"
            :disabled="!platform || successCopy"
            block
          >
            <v-icon v-if="successCopy" left>mdi-check</v-icon>
            <v-icon v-else left>mdi-content-copy</v-icon>
            {{ successCopy ? "Copiado!" : "Copiar" }}
          </v-btn>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PlatformSelector from "@/components/global/PlatformSelector.vue";
import SUPPORT from "@/services/support";
export default {
  components: { PlatformSelector },
  props: {
    data: Object,
  },
  data() {
    return {
      show: false,
      loading: false,
      platform: null,
      token: null,
      confirm: false,
      successCopy: false,
      reason: "CREATE_ACCOUNT",
      types: [
        { text: "Criação de conta", value: "CREATE_ACCOUNT" },
        // { text: "Redefinição de senha", value: "RESET_PASSWORD" },
      ],
      error: null,
      link: null,
    };
  },
  methods: {
    open() {
      this.token = null;
      this.show = true;
      this.error = null;
      this.loading = false;
      this.confirm = false;
      this.link = null;
    },
    async create() {
      try {
        this.loading = true;
        this.error = null;
        if (this.token) return this.copy();
        const confirm =
          this.confirm ||
          window.confirm(
            `Confirme que o número do cliente é ${this.data.user.phone} antes de copiar o link.`
          );
        if (!confirm) return;

        const { user } = this.data;
        const { platform, reason } = this;
        const { token } = await SUPPORT.createToken({
          userId: user.id,
          platformId: platform.id,
          reason,
        });
        this.token = token;
        this.copy();
      } catch (e) {
        console.error(e);
        this.error = e.message || "Erro ao criar token";
      } finally {
        this.loading = false;
      }
    },
    copy() {
      const url = new URL(
        `https://${this.platform.domain}/auth/register?token=${this.token.id}`
      );
      const text = `Olá, clique no link para criar sua conta\n${url.toString()}`;
      this.link = text;
      navigator.clipboard.writeText(text);
      this.successCopy = true;
      setTimeout(() => {
        this.successCopy = false;
      }, 3000);
    },
  },
  mounted() {
    this.$root.$on("create_token", (token) => {
      this.open(token);
    });
  },
};
</script>
